<template>
    <div >
      <img class="topimg" src="../assets/newimg/images/logo_03_03.png">
      <form>
        <div class="input-control">
          <input placeholder="输入设备号" v-model="iccid" />
          <img class="addon" v-if="wxReady" @click="handleScan" src="../assets/images/scan.png">
        </div>
        <template v-if="cardCheckOK==true && needAuth == 1 && binded==false">
          <!--<div class="input-control">
            <input v-model="ruleForm.name" placeholder="使用人姓名" />
          </div>-->
          <div class="input-control">
            <input v-model="ruleForm.mobile" placeholder="输入手机号" />
            <span class="smscode" @click="handleSms">{{smsBtnTxt}}</span>
          </div>

          <div class="input-control">
            <input v-model="ruleForm.code"  placeholder="输入验证码" />
          </div>
        </template>

        <template v-else-if="binded==true && needAuth ==1 ">
          <!--<div class="input-control">
            <input v-model="bindInfo.username" disabled placeholder="使用人姓名" />
          </div>-->
          <div class="input-control">
            <input v-model="bindInfo.mobile" disabled placeholder="输入手机号" />
          </div>
          <div style="font-size: .24rem;color: #000;">以上信息为此号码当前绑定的使用人信息，如有疑问，请联系客服</div>
        </template>
          <div class="btn" @click="handleCheckCard" v-if="cardCheckOK==false">查询</div>
          <div class="btn" @click="handleBindCard" v-else-if="binded==false">绑定</div>
          <div class="btn" @click="handleQueryCard" v-else-if="binded==true">确认</div>
      </form>
      <div class="tips">
        <div class="title">温馨提示：</div>
        <div>1：卡号为卡芯后的数字，短号为设备背面的字母和数字</div>
        <div>2：因产品实名使用之后，无法二次销售，故无法退卡</div>
        <div>3：绑卡时请核实该地区是否能使用，谨慎操作</div>
        <div>4：新疆、西藏、云南、港澳台不可使用!</div>
      </div>
      <van-dialog v-model="xieyimodal" :showConfirmButton="false">
        <div class="xieyibox" :style="{maxHeight: dialogHeight,overflowY: 'scroll'}">
          <div class="xy-title">免责声明</div>
          <div class="xy-content">
            <div class="xy-heading">购买须知</div>
            1、套餐规则

            1）套餐随用随充，均为全国流量（不含港澳台和运营商指定限制上网区域，目前运营商限制区域包括：新疆全境、西藏全境、云南全境）。

            2）套餐分为基础套餐和定额套餐。基础套餐指按固定周期（月/季/半年/年）订购的流量套餐，周期内每月享有固定流量额度；定额套餐是指套餐有效期内流量总量为固定值的套餐。

            3）当前若无其他有效基础套餐或定额套餐，所购套餐立即生效，购买时间即生效时间。当前仅可有一个基础套餐或定额套餐生效，套餐到期后立即失效。当基础套餐最后一个周期流量用尽且无可用的加油包或定额套餐流量用尽时，若此时订购新的基础套餐或定额套餐，则原套餐失效，新购套餐生效。

            4）购买套餐后须完成实名认证方可使用：购买双网套餐且完成全部实名认证后，则可切换网络使用，若只对其中某一运营商实名认证，则无法切换网络使用；如需切换网络使用，则需对另一运营商实名认证。

            5）由于中国移动管控要求，当月移动网络流量会有40G的用量限制，超出后为您提供中国电信的网络流量，请您务必实名认证并激活电信卡。

            6）根据工信部和基础运营商的政策变化情况，可能对流量套餐价格进行浮动调整。

            7）离网（无有效套餐）180天内可随时启用；离网超过180天，请联系客服确认是否可以重新启用。

            2、基础套餐

            1）套餐有效期：基础套餐中，月包套餐有效期为30个自然日；季包套餐有效期为90个自然日；半年包套餐有效期为180个自然日；年包套餐有效期为360个自然日；套餐有效期自套餐生效次日起计算，以月包套餐为例：2025年6月10日激活使用，月包到期时间为2025年7月10日。

            2）流量结转规则：长周期（每30个自然日为一个周期，简称：期）基础套餐的当期未使用完流量不可结转至次期，即当期未用尽流量将在本期最后一天23:59自动清零。当期流量用尽可自主选购“加油包”继续使用。

            3）加油包：必须依托于一个正在生效中的基础套餐方可购买。加油包的网络类别、覆盖地区等属性均与当前基础套餐相同，购买后立即生效，当期基础套餐到期后，加油包亦同步失效，流量自动清零不可结转。

            4）退订规则：

            ①月包套餐：退订时，已使用流量部分按照1元/G标准收取费用，最高不超过当月套餐购买价格；套餐到期后，不支持退订。

            ②长周期套餐（季包套餐、半年包套餐、年包套餐）：退订时，已使用流量部分按照【使用月数（含当月）*月包套餐价格】的标准收取费用，最高不超过该长周期套餐购买价格；套餐剩余使用期限小于或等于一个月的，不予退款。

            ③退订顺序：基础套餐退订时如有流量未用尽的加油包，则先退订加油包再退订基础套餐。加油包退款规则同月包基础套餐。

            ④退款说明：退款金额为实际支付金额扣除前述应收取费用。若您在支付时选择使用优惠券，则套餐退订时，所使用优惠券（如有）无法退还。

            3、定额套餐

            1）套餐有效期：定额套餐中，半年包套餐有效期为90个自然日，180个自然日，年包套餐有效期为360个自然日；套餐有效期自套餐生效次日起计算，以年包套餐为例：2025年6月10日激活使用，年包到期时间为2026年6月5日。

            2）流量使用规则：套餐有效期内，套餐内流量可自由使用，流量用尽时套餐自动失效。定额套餐不支持加油包的订购，套餐到期后，未使用流量自动清零，不可延期或结转；流量用尽但未到期时，需重新购买流量套餐使用。

            3）退订规则：退订时，已使用的流量部分将按照1元/G的标准收取费用，且所收取的费用最高不超过该流量包的购买价格退款金额为实际支付金额扣除前述应收取费用。套餐到期后，不支持退订。若您在支付时选择使用优惠券，则套餐退订后，所使用优惠券（如有）无法退还。
          </div>
          <div class="btn">
            <div @click="confirmxieyi">同意</div>
            <div @click="xieyimodal = false">取消</div>
          </div>
        </div>
      </van-dialog>
    </div>
</template>
<script>
    import wx from "weixin-js-sdk";
    export default {
        name: "bind",
        data() {
            return {
              xieyimodal:true,
                iccid: '',
                cardLengthCheck:false,
                errMsg: false,
                cardCheckOK:false,
                wxReady:false,
                sms:false,
                binded:false,
                bindInfo:{},
                needAuth:0,
                token:'',
              showList:false,
              dialogHeight:'',
                cardlist:[],
                smsBtnTxt:'发送验证码',
                ruleForm:{
                    iccid:'',
                    mobile:'',
                    name:'',
                    code:''
                }
            };
        },
        watch:{
            iccid(iccid){
                this.iccid = iccid.toUpperCase();
                this.cardCheckOK = false;
                this.needAuth = 0;
                this.binded = false
                if(this.iccid.indexOf('C') !== -1){
                    //移动卡二十位
                    if(this.iccid.length == 20 || (this.iccid.length >= 6 && this.iccid.length <= 10)){
                        this.cardLengthCheck = true
                    }else{
                        this.cardLengthCheck = false
                    }
                }else{
                    if(this.iccid.length == 19  || (this.iccid.length >= 6 || this.iccid.length <= 10)){
                        this.cardLengthCheck = true
                    }else{
                        this.cardLengthCheck = false
                    }
                }
            }
        },
      mounted() {
        this.dialogHeight= window.innerHeight *0.8+'px';
      },
      methods: {
            handleCheckCard(){
              let xieyi = localStorage.getItem('xieyi');
              if(!xieyi){
                this.xieyimodal = true
                return false
              }
                this.errMsg = '';
                this.cardCheckOK = false;
                this.binded = false;
                this.$toast.loading('查询中');
                localStorage.setItem("iccid",this.iccid)
                this.fetchData('/card/queryCard',{iccid:this.iccid},(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        this.cardCheckOK = true
                        this.needAuth = res.data.needAuth
                        if(this.needAuth == 0) {
                            this.$router.push({name: 'index'})
                        }else if(res.data.mobile){
                            /*this.binded = true
                            this.bindInfo = res.data*/
                          this.handleQueryCard()
                        }
                    }else{
                      if(res.url){
                        window.location.href = res.url
                        return;
                      }
                      this.$notify(res.msg);
                        this.errMsg = res.msg
                    }
                })
            },
            handleQueryCard(){
                this.$router.push({name:'index',query:{iccid:this.iccid}})
            },
            handleBindCard(){
                this.$toast.loading('绑定中')
                this.ruleForm.iccid = this.iccid
                this.fetchDataPost('/card/bind',this.ruleForm,(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        this.$toast.success(res.msg);
                        this.$router.push({name:'index'})
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            },
            initWechatJs(){
                let url = encodeURIComponent(location.href.split('#')[0])
                this.fetchData('/wechat/jssdk',{url:url},(res)=>{
                    if(res.code){
                        wx.config(res.data);
                        wx.ready(()=>{
                            this.wxReady = true;
                        })
                    }
                })
            },
            handleScan(){
                wx.scanQRCode({
                    needResult: 1,
                    scanType: ["barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                    success:(res)=>{
                        if(res.resultStr.includes(',')){
                            this.iccid = res.resultStr.split(',')[1];
                        }else {
                            this.iccid = res.resultStr;
                        }

                    }
                })
            },
            getCardListByOpenid(openid){
              this.fetchData('/card/querylist', {}, (res) => {
                console.log(res)
                if (res.code) {
                  for (var i in res.data) {
                    let card = res.data[i];
                    this.cardlist.push({
                      name: card.iccid,
                      value: card.iccid
                    })
                    if (card.default == 1) {
                      this.iccid = card.iccid;
                    }
                  }
                  if(!this.iccid && res.data && res.data[0]){
                    this.iccid = res.data[0].iccid
                  }
                }
              })
            },
            handleSms(){
                if(this.sms == false) {
                    this.sms = true
                    this.$toast.loading()
                    this.fetchData('/sms/send', {mobile: this.ruleForm.mobile}, (res) => {
                        this.$toast.clear();
                        if (res.code) {
                            this.$toast.success('发送成功')
                            let s = 60;
                            let intval = setInterval(()=>{
                                this.smsBtnTxt = s+'秒重发'
                                if(s <= 0){
                                    this.smsBtnTxt = '发送验证码';
                                    this.sms = false;
                                    clearInterval(intval);
                                }
                                s--;
                            },1000)

                        } else {
                            this.sms = false;
                            this.$toast.fail('发送失败')
                        }
                    })
                }
            },
          confirmxieyi(){
              localStorage.setItem('xieyi',1);
              this.xieyimodal = false
          }
        },
        created: function () {
            let xieyi = localStorage.getItem('xieyi');
            if(!xieyi) this.xieyimodal = true
            this.initWechatJs()
            if(this.$route.query.cardno){
                this.iccid = this.$route.query.cardno
            }else if(!this.$route.query.nostorage){
              this.iccid = localStorage.getItem("iccid");
            }
            if(this.iccid){
              if(this.$route.query.auto) {
                this.handleCheckCard()
              }
            }else if(!this.$route.query.nostorage){
              let openid = sessionStorage.getItem('token')
              if(!openid && this.$route.query.appid){
                this.$router.push({name: 'login',query:{appid:this.$route.query.appid,path:'/'}})
              }else if(openid){
                this.getCardListByOpenid(openid)
              }
            }

        }
    };
</script>
<style scoped lang="scss">
  .xieyibox{
    padding: .2rem .4rem;
    background: #fff;
    text-align: center;
    font-size: 0;
    .btn{
      margin-top: .28rem;
      display: flex;
      justify-content: space-between;
      gap: .3rem;
      div{
        flex: 1;
        display: block;
        width: auto;
        height: .6rem;
        text-align: center;
        line-height: .6rem;
        color: #fff;
        font-size: .28rem;
        border-radius: .2rem;
        background: rgb(254, 104, 113);
      }
      :last-child{
        margin-left: 0;
        background: #bdbdbd;
      }
    }
    .xy-title{
      letter-spacing: .1rem;
      color: rgb(254, 104, 113);
      font-size: .34rem;
      text-align: center;
      font-weight: bold;
      border-bottom: 1px dotted #eee;
      padding-bottom: .2rem;
    }
    .xy-content{
      padding-top: .14rem;
      text-align: left;
      white-space: pre-line; // 保留原文换行
      font-size: .26rem;
      color: #555;
      line-height: 1.55;
      word-break: break-word;
      letter-spacing: .02rem;
      .xy-heading{
        text-align: center;
        font-weight: 700;
        font-size: .3rem;
        color: #333;
        margin-bottom: .04rem;
        line-height: 1.2;
      }
    }
  }
  .tips{
    .title{
      line-height: 2;
      font-size: .3rem;
    }
    width: 6.2rem;
    margin: 1rem auto 0;
    color: #fff;
    font-size: .25rem;
    line-height: 1.6;
  }
  .topimg {
   width: 5rem;
    display:block;
    margin: 1rem auto;
  }
  form{
    font-size: .34rem;
    display: block;
    width: 6.2rem;
    margin: .2rem auto;
.btn{
  font-size: .36rem;
  width: 2.16rem;
  height: .56rem;
  line-height: .56rem;
  text-align: center;
  background: #28a8fa;
  border-radius: .4rem;
  color: #fff;
  margin: .4rem auto 0;
}
    .input-control{
      position: relative;
      width: 100%;
      height: .76rem;
      line-height: .76rem;
      background: #fff;
      margin-bottom: .6rem;
      input{
        display: block;
        width: 100%;
        height: 100%;
        background: #fff;
        border: none;
        text-indent: .4rem;
      }
      input[disabled]{
        background: #dfdfdf;
      }
      .addon{
        position: absolute;
        right: .1rem;
        top: .13rem;
        height: .5rem;
        width: .5rem;
      }
      .smscode{
        position: absolute;
        right: .1rem;
        top: .13rem;
        line-height: 1;
        padding: .1rem .2rem;
        border-radius: .2rem;
        color: #fff;
        background: #28a8fa;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/bind.vue